import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BreakdownService {

  private selectedBreakdownSubject = new BehaviorSubject<any[]>([]);
  selectedBreakdown$ = this.selectedBreakdownSubject.asObservable();

  setSelectedBreakdown(selected: any[]) {
    this.selectedBreakdownSubject.next([...selected]);    
  }

  getSelectedBreakdown(): any[] {
    return this.selectedBreakdownSubject.getValue();
  }
}
